// import StageOne from "../Views/StageOne";
import WaitingScreen from "../Views/WaitingScreen";

const routes = [{ path: "/waiting-room", element: <WaitingScreen /> }];

export default routes;
